import DriverTaxiDriverAssociationsRequest from "../../../../api/raily/driver/taxi-driver/associations/driver-taxi-driver-associations.request";
import DriverTaxiDriverAssociationsParams from "./driver-taxi-driver-associations-params";

const create = (
  params: DriverTaxiDriverAssociationsParams,
): DriverTaxiDriverAssociationsRequest => {
  return {
    driverUuid: params.driverUuid,
  };
};

const driverTaxiDriverAssociationsParamsFactory = {
  create,
};

export default driverTaxiDriverAssociationsParamsFactory;
